import * as React from 'react'
import { Connect } from '@selkirk-systems/state-management';
import StatusesStore from '@@/stores/StatusesStore';
import { Column, Row } from '@selkirk-systems/layout';
import Typography from '@@/components/General/Typography';
import { Skeleton } from 'primereact/skeleton';
import stc from 'string-to-color';

class StatusList extends React.Component{


    static subscribe=[StatusesStore];


    static defaultProps={
        data:[]
    }


    static storeStateToProps={
        data:( props,state )=>state.data
    }


    render(){

        const {data,...other} = this.props;

        if(!data) return (
            <Column gap='md' justify='center'>
                {[...new Array(6)].map((item,i)=>{
                    return (
                        <Skeleton key={i} width="100%" height="30px"/>
                    )
                })}
            </Column>
        )

        return (
            <Column gap='md' justify='center' {...other}>
                {data.map(item=>{
                    return (
                        <Row key={item.value} className='no-wrap' gap='sm' align='center' xs="auto 1fr 6fr" justify='left'>
                            <div className="legend-color" style={{background:item.color || stc(item.value)}}></div>
                            <Typography variant="h6" className="legend-count no-wrap" mr='sm'>{item.count}</Typography>
                            <Typography variant="h6" className="legend-label no-wrap">{item.value}</Typography>
                        </Row>
                    )
                })}
            </Column>    
        )
    }
}


export default Connect( StatusList );